<template>
  <div class="d-flex flex-column gap-12 mb-6" id="pdf">
    <!--PRINT HEADER-->
    <div
      class="d-flex flex-column align-center to-show"
      style="gap: 14px; display: none; visibility: hidden; height: 0px"
    >
      <div class="d-flex align-center">
        <v-img
          :src="require('@/assets/Logo2.png')"
          width="146"
          height="48"
          aspect-ratio="1"
        ></v-img>
      </div>

      <div class="d-flex align-center">
        <div class="page-title">แบบฟอร์มข้อเสนอโครงการ</div>
      </div>
      <div class="d-flex align-center">
        <div class="txt-head">โดยอุทยานวิทยาศาสตร์ {{ user.region ?? "" }}</div>
      </div>
    </div>

    <!--  PART ONE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="
                masterData.plan_master[0]?.plan_name_th ? true : false
              "
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">แผนงาน</div>
              <div>{{ masterData.plan_master[0]?.plan_name_th }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="masterData.form_b.region ? true : false"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">อุทยานวิทยาศาสตร์</div>
              <div>{{ masterData.form_b.region }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-24">
            <div class="font-type-bold black--text mb-3">
              ข้อมูลผู้รับผิดชอบโครงการ
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pm_name')"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ partOneForm.pm_name }}</div>
            </div>
          </div>

          <!-- Form 1 #line5 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pm_position')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำแหน่ง</div>
              <div>{{ partOneForm.pm_position }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">หน่วยงาน</div>
              <div>{{ partOneForm.pm_org }}</div>
            </div>
          </div>

          <!-- Form 1 #line6 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="true"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์</div>
              <div>{{ partOneForm.pm_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรสาร</div>
              <div>{{ partOneForm.pm_fax }}</div>
            </div>
          </div>

          <!-- Form 1 #line7 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pm_mobile_phone')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์มือถือ</div>
              <div>{{ partOneForm.pm_mobile_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-Mail</div>
              <div>{{ partOneForm.pm_email }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 1 Part 2 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 Part 2 #line1 -->
          <div class="d-flex gap-24">
            <div class="font-type-bold black--text mb-3">
              ข้อมูลผู้ประสานงานโครงการ
            </div>
          </div>

          <!-- Form 1 Part 2 #line2 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pc_name')"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ partOneForm.pc_name }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line3 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pc_position')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำแหน่ง</div>
              <div>{{ partOneForm.pc_position }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">หน่วยงาน</div>
              <div>{{ partOneForm.pc_org }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line5 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="true"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์</div>
              <div>{{ partOneForm.pc_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรสาร</div>
              <div>{{ partOneForm.pc_fax }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line6 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pc_mobile_phone')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์มือถือ</div>
              <div>{{ partOneForm.pc_mobile_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-Mail</div>
              <div>{{ partOneForm.pc_email }}</div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART TWO  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partTwoValidate('principle')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="font-type-bold black--text">1. หลักการและเหตุผล</div>
              <div v-html="partTwoForm.principle?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form 2 -->
      <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('objective')"
          ></ValidatorIcon>
          <div class="flex xs6 d-flex gap-16">
            <div class="font-type-bold black--text">2. วัตถุประสงค์</div>
            <div v-html="partTwoForm.objective?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>
      </div>

      <!-- Form 3 -->
      <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('industry_group')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            3. กลุ่มอุตสาหกรรมที่มุ่งเน้นและกลุ่มอุตสาหกรรมเป้าหมาย
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div
                v-html="partTwoForm.industry_group?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form 4 -->
      <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('target')"
          ></ValidatorIcon>
          <div class="flex xs6 d-flex gap-16">
            <div class="font-type-bold black--text">
              4. เป้าหมาย
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
            <div v-html="partTwoForm.target?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>
      </div>

      <!-- Form 5 -->
      <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('five')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            5. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8 mb-4">
          <div class="black--text mb-2">
            ศักยภาพความพร้อมของเจ้าหน้าที่และบุคลากร
          </div>
          <div
            v-html="partTwoForm.officer_potential?.replace(/\n/g, '<br>')"
          ></div>
        </div>
        <div class="indent-info d-flex flex-column gap-8 mb-4">
          <div class="black--text mb-2">
            องค์ความรู้เพื่อสนับสนุนผู้ประกอบการ
          </div>
          <div v-html="partTwoForm.knowledge?.replace(/\n/g, '<br>')"></div>
        </div>
        <div class="indent-info d-flex flex-column gap-8 mb-4">
          <div class="black--text mb-2">
            การเชื่อมโยงกับผู้เชี่ยวชาญที่ให้คำปรึกษาและหน่วยงาน/เครือข่ายภายนอก
          </div>
          <div v-html="partTwoForm.expert?.replace(/\n/g, '<br>')"></div>
        </div>
        <div class="indent-info d-flex flex-column gap-8 mb-4">
          <div class="black--text mb-2">
            รูปแบบการให้บริการพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยให้กับภาคเอกชน
          </div>
          <div
            v-html="partTwoForm.tech_service_model?.replace(/\n/g, '<br>')"
          ></div>
        </div>
      </div>

      <!-- Form 6 -->
      <div class="card-part" v-if="isFinal">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('progress')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            6. ขั้นตอนและขอบเขตการดำเนินโครงการ
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8">
          <div class="d-flex gap-16">
            <div class="flex xs6 d-flex gap-16">
              <div v-html="partTwoForm.progress?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form 7 -->
      <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('seven')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            {{ isFinal ? "7." : "6." }} ผลการดำเนินงานที่ผ่านมา
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8 mb-4">
          <div class="black--text mb-2">
            ภาพรวมผลการดำเนินงานของผู้ประกอบการที่เข้าร่วมโครงการในปีงบประมาณที่ผ่านมา
          </div>
          <div v-html="partTwoForm.overview?.replace(/\n/g, '<br>')"></div>
        </div>
        <div class="indent-info d-flex flex-column gap-8 mb-4">
          <div class="black--text mb-2">
            แนวทางที่จะปรับปรุงและพัฒนาการให้บริการโดยประเมินจากการดำเนินงานที่ผ่านมา
          </div>
          <div
            v-html="partTwoForm.impr_direction?.replace(/\n/g, '<br>')"
          ></div>
        </div>
      </div>
      <!-- Form 8 -->
      <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('future_service')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            {{ isFinal ? "8." : "7." }} แนวความคิด (new initiative)
            ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div class="indent-info d-flex flex-column gap-8 mb-4">
          <div
            v-html="partTwoForm.future_service?.replace(/\n/g, '<br>')"
          ></div>
        </div>
      </div>
    </divcard>

    <!--  PART THREE  -->
    <divcard titled>
      <div class="card-part pt-0 s3-p1-h">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนการดำเนินงานวิจัย
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partThreeValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              1.แผนการดำเนินงานวิจัย (จัดทำในรูปเเบบ Project based management)
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll s3-p1">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div
                class="flex text-center"
                style="min-width: 43px; max-width: 43px"
              >
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div
              v-if="partThreeAllPlans && partThreeAllPlans.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in partThreeAllPlans"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8 no-box-shadow"
              >
                <div class="d-block">
                  <div
                    class="flex two-line"
                    style="min-width: 120px; max-width: 120px; max-height: 45px"
                  >
                    <!-- {{ item.p1_activity_name }} -->
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field tf-active"
                    style="min-width: 40px; max-width: 40px; height: 100%"
                  >
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in item.project_section_plan_month"
                  :key="ind"
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{ m.month_value ? m.month_value : "-" }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{ m.actual_month_value ? m.actual_month_value : "-" }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                          parseFloat(
                            item.project_section_plan_month[currIndex]
                              ?.month_value
                          ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card no-box-shadow">
                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field"
                      :class="{
                        'theme-color-four tf-error': totalWF() !== '1.00',
                      }"
                      style="min-width: 40px; max-width: 40px"
                    >
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(currIndex) }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(shortMonths.length - 1) }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? weightPlan(ind, "actual_month_value") : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? weightPlan(currIndex, "actual_month_value")
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              weightPlan(currIndex, "actual_month_value") * 100
                            ) / parseFloat(weightPlan(currIndex)),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                   <ValidatorIcon
                      v-if="!$route.query.preview"
                      :is-correct="validatePlanBudget()"
                    ></ValidatorIcon>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนการใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[ind]?.plan_budget_rate
                        ? partThreeBudgetPlans[ind]?.plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[currIndex]?.plan_budget_rate
                        ? partThreeBudgetPlans[currIndex].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[shortMonths.length - 1]
                        ?.plan_budget_rate
                        ? partThreeBudgetPlans[shortMonths.length - 1]
                            ?.plan_budget_rate
                        : "-"
                    }}
                  </div>
                </div>
                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && partThreeBudgetPlans[ind]?.use_budget_rate
                        ? formatNumber(
                            partThreeBudgetPlans[ind].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal &&
                      partThreeBudgetPlans[currIndex]?.use_budget_rate
                        ? formatNumber(
                            partThreeBudgetPlans[currIndex].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              partThreeBudgetPlans[currIndex]?.use_budget_rate *
                                100
                            ) /
                              parseFloat(
                                partThreeBudgetPlans[currIndex]
                                  ?.plan_budget_rate
                              ),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>

      <div class="card-part" v-for="(item, i) in partThreeBudgetList" :key="i">
        <div class="mb-5" v-if="i === 0">
          <!--Form 2 budget-->
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partThreeValidate('two')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">2.งบประมาณ</div>
          </div>
        </div>
        <div class="indent-info d-flex flex-column gap-8">
          <!-- Form 7 #line1 -->
          <div class="flex-center gap-16 pr-6">
            <div class="flex d-flex justify-space-between">
              <div class="mb-1 black--text">
                {{ item.budget_name }}
              </div>
              <div v-if="!item.have_budget_detail">
                {{ formatNumber(item.budget_amount_rsp, 2) }} บาท
              </div>
              <div v-else></div>
            </div>
          </div>
          <div class="flex-center gap-16 pr-6">
            <div class="flex pl-10" v-if="item.have_budget_detail">
              <ul>
                <li v-for="(detail, i) in item.form_ab_budget_detail" :key="i">
                  <div class="d-flex justify-space-between">
                    <div>{{ detail.budget_detail_name }}</div>
                    <div>
                      {{ formatNumber(detail.budget_detail_amount, 2) }} บาท
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-part">
        <div class="indent-info d-flex flex-column gap-8">
          <div class="flex-cetner d-flex justify-space-between pr-6">
            <div>รวม</div>
            <div>
              {{
                formatNumber(
                  partThreeBudgetList
                    .map((x) => parseFloat(x.budget_amount_rsp))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partThreeValidate('oa_list')"
          ></ValidatorIcon>

          <div class="font-type-bold black--text">
            3. กิจกรรมการดำเนินงาน
            <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
          </div>
        </div>

        <div v-if="OAList">
          <div
            v-for="(item, i) in OAList"
            :key="i"
            class="indent-info d-flex flex-column gap-8 mb-4"
          >
            <div class="black--text mb-2">กิจกรรม: {{ item.activity }}</div>
            รายละเอียด:
            <div v-html="item.description?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART FOUR  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> OOI /
          ตัวชี้วัดความสำเร็จ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partFourValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">1. ตัวชี้วัดความสำเร็จ</div>
          </div>

          <div class="d-flex black--text font-type-bold mb-5 gap-24">
            <div style="width: 50%"></div>
            <div style="width: 25%; text-indent: 30%">RSP</div>
            <div style="width: 25%; text-indent: 30%">สป.อว.</div>
          </div>

          <div class="d-flex flex-column gap-16">
            <div v-for="(plan, pi) in masterData.plan_master" :key="pi">
              <div class="black--text font-type-bold mb-5">
                {{ plan.plan_name_th }}
              </div>

              <div v-for="(kpiItem, ind) in plan.kpi_masters" :key="ind">
                <div
                  v-if="!kpiItem.prefix_flag"
                  class="d-flex flex-column mt-2"
                >
                  <div class="flex d-flex align-center justify-space-between">
                    <div
                      class="black--text d-flex gap-12 pl-10"
                      style="width: 50%"
                    >
                      <div
                        class="font-type-bold flex"
                        style="min-width: 80px; max-width: 80px"
                      >
                        {{
                          exceptShowKPINo.includes(kpiItem.no)
                            ? ""
                            : "ตัวชี้วัดที่ " + kpiItem.no
                        }}
                      </div>
                      <div class="flex">{{ kpiItem.name }}</div>
                    </div>
                    <div
                      v-if="kpiItem.no !== '22'"
                      class="d-flex gap-12"
                      style="width: 25%"
                    >
                      <div
                        class="font-type-bold flex pt-2 text-center"
                        style="min-width: 80px; max-width: 80px"
                      >
                        {{
                          kpiItem.kpi_values
                            ? formatNumber(kpiItem.kpi_values.kpi_value)
                              ? formatNumber(kpiItem.kpi_values.kpi_value)
                              : "-"
                            : "-"
                        }}
                      </div>
                      <div class="pt-2" style="min-width: 130px">
                        {{ kpiItem.unit }}
                      </div>
                    </div>
                    <div
                      v-if="kpiItem.no !== '22'"
                      class="d-flex gap-12"
                      style="width: 25%"
                    >
                      <div
                        class="font-type-bold flex pt-2 text-center"
                        style="min-width: 80px; max-width: 80px"
                      >
                        {{
                          kpiItem.kpi_values
                            ? formatNumber(kpiItem.kpi_values.kpi_value_ops)
                              ? formatNumber(kpiItem.kpi_values.kpi_value_ops)
                              : "-"
                            : "-"
                        }}
                      </div>
                      <div class="pt-2" style="min-width: 130px">
                        {{ kpiItem.unit }}
                      </div>
                    </div>
                  </div>
                  <div v-if="kpiItem.no !== '22'" class="d-flex">
                    <div v-if="kpiItem.desc_flag" class="d-flex pl-10">
                      <div style="min-width: 100px; max-width: 100px"></div>
                      <div style="font-weight: bold">
                        {{ kpiItem.desc_label }}:
                      </div>
                      <div class="pl-2">
                        {{
                          kpiItem.kpi_values
                            ? kpiItem.kpi_values.description
                            : "-"
                        }}
                      </div>
                    </div>
                  </div>
                  <div v-else class="d-flex mt-4">
                    <div
                      class="pb-6 black--text d-flex gap-12 pl-10"
                      style="width: 50%"
                    >
                      <div
                        class="font-type-bold flex"
                        style="min-width: 80px; max-width: 80px"
                      ></div>
                      <div class="flex">
                        มีการรายงานผลการใช้งบประมาณที่ได้รับการรับรองจาก
                        ผู้ตรวจบัญชี ตามพรบ.วีธีการงบประมาณ 2563
                      </div>
                    </div>
                    <div
                      class="flex text-center font-type-bold"
                      style="width: 25%"
                    >
                      <span>{{
                        kpiItem.kpi_values
                          ? kpiItem.kpi_values.kpi_value == 1
                            ? "มี"
                            : "ไม่มี"
                          : "-"
                      }}</span>
                    </div>
                  </div>
                </div>

                <div v-else class="font-type-bold black--text pl-10  mb-2">
                  {{ kpiItem.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form 2 -->
      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partFourValidate('kpi_quantity')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">2. ผลลัพธ์และผลกระทบ</div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <div
                v-html="partOneForm.kpi_quantity?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>
          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <div
                v-html="partOneForm.kpi_quality?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form 3 -->
      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partFourValidate('kpi_annex_project')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">ภาคผนวก</div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="d-flex flex-column gap-16">
                <div v-if="kpi_annex_projects">
                  <div
                    v-for="(item, i) in kpi_annex_projects"
                    :key="i"
                    class="d-flex gap-16"
                  >
                    <div class="flex xs6 d-flex gap-16">
                      <div class="mb-1 black--text topic-field">
                        โครงการที่ {{ i + 1 }}
                      </div>
                    </div>

                    <div class="flex xs6 d-flex gap-16">
                      <div>
                        {{
                          item?.form_c?.project_section_general_info
                            ?.project_name_th
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART FIVE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div><span class="theme-color-one">ส่วนที่ 5 :</span> เอกสารแนบ</div>
        </div>

        <!-- Form 1 -->
        <div>
          <v-layout
            align-center
            class="mt-3"
            v-for="(file, f) in partFiveAttachment"
            :key="f"
          >
            <v-flex shrink class="to-hide">
              <v-btn
                depressed
                dark
                rounded
                width="125"
                color="#F15A29"
                @click="downloadFile(file)"
              >
                <Iconify
                  style="color: #fff"
                  icon="system-uicons:download"
                ></Iconify>
                <span class="font-12 font-w-700">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              {{ file.file_name }}
            </v-flex>
          </v-layout>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import {
  eventBus,
  formatNumber,
  validateEmail,
} from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import OOILineField from "../../../components/OOILineField";
import ValidatorIcon from "../../../components/ValidatorIcon";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import { apiDomain } from "@/store/constants";
import axios from "axios";

export default {
  name: "BFormSummary",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      partOneForm: {},
      partTwoForm: {},
      shortMonths: [],
      partThreeForm: {},
      partThreeAllPlans: [],
      partThreeBudgetList: [],
      partThreeBudgetPlans: [],
      partThreeAllProgressPlan: [],
      partFourForm: {},
      kpi: {},
      annexProjects: [],
      partFiveAttachment: [],
      OAList: [],
      kpi_annex_projects: [],
      ableToSubmit: true,
      exceptShowKPINo: ["20.1", "20.2", "20.3", "20.4", ""],
    };
  },
  computed: {
    ...mapState({
      userRole: (state) => state.Auth.User.user_type,
      user: (state) => state.Auth.User,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  async created() {
    this.ableToSubmit = true;

    this.fiscalYear = this.masterData.form_b.fiscal_year;
    // PART ONE
    this.partOneForm = this.masterData.form_b?.form_ab_general_info;
    // PART TWO
    this.partTwoForm = this.masterData.form_b?.form_ab_project_info;
    // PART THREE
    this.setupBudgetYearMonth();
    this.partThreeForm = this.masterData.form_b?.project_section_plan;
    this.partThreeAllPlans =
      this.masterData.form_b?.project_section_plan.project_plan_p1;
    this.partThreeBudgetList = this.masterData.form_b?.form_ab_budget || [];
    this.partThreeBudgetPlans =
      this.masterData.form_b.project_section_plan
        .project_section_plan_p1_budget || [];
    // PART FOUR
    this.kpi_annex_projects = this.masterData.form_b?.kpi_annex_project;
    // PART FIVE
    this.partFiveAttachment = this.masterData.form_b?.attachments || [];
    this.OAList = this.masterData.form_b.operating_activities || [];
    this.currIndex = this.getCurrIndex();
  },
  methods: {
    totalWF() {
      if (!this.partThreeAllPlans || this.partThreeAllPlans.length === 0)
        return "-";
      let total = this.partThreeAllPlans
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(index, field = "month_value") {
      let total = [];
      for (const x of this.partThreeAllPlans) {
        let result = x.project_section_plan_month[index]
          ? parseFloat(x.project_section_plan_month[index][field] * x.p1_wf)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.partThreeAllPlans) {
        let i = 0;
        for (const y of x.project_section_plan_month) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    setupBudgetYearMonth() {
      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      for (let i = 0; i < 12; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },

    sumBudget() {
      if (!this.partThreeBudgetList || this.partThreeBudgetList.length === 0)
        return "-";
      let total = 0;
      for (const x of this.partThreeBudgetList) {
        if (x.have_budget_detail) {
          for (const y of x.form_ab_budget_detail) {
            total += parseFloat(y.budget_detail_amount);
          }
        } else {
          total += parseFloat(x.budget_amount_ops);
        }
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("bFormAbleToSubmit", this.ableToSubmit);
    },

    partOneValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "pm_name":
          if (!this.partOneForm.pm_name) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pm_position":
          if (!this.partOneForm.pm_position) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pm_mobile_phone":
          if (
            !this.partOneForm.pm_mobile_phone ||
            !validateEmail(this.partOneForm.pm_email)
          ) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pc_name":
          if (!this.partOneForm.pc_name) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pc_position":
          if (!this.partOneForm.pc_position) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pc_mobile_phone":
          if (
            !this.partOneForm.pc_mobile_phone ||
            !validateEmail(this.partOneForm.pc_email)
          ) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    partTwoValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "principle":
          if (!this.partTwoForm.principle) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "objective":
          if (!this.partTwoForm.objective) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "industry_group":
          if (!this.partTwoForm.industry_group) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "target":
          if (!this.partTwoForm.target) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "future_service":
          if (!this.partTwoForm.future_service) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "five":
          if (
            !this.partTwoForm.officer_potential ||
            !this.partTwoForm.knowledge ||
            !this.partTwoForm.expert ||
            !this.partTwoForm.tech_service_model
          ) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "progress":
          if (!this.partTwoForm.progress) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "seven":
          if (!this.partTwoForm.overview || !this.partTwoForm.impr_direction) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    partThreeValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (
            !this.partThreeAllPlans ||
            this.partThreeAllPlans.length < 1 ||
            this.totalWF() !== "1.00"
          ) {
            isCorrect = false;
          }

          // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
          if (
            this.partThreeBudgetPlans.filter((x) => x.plan_budget !== "")
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != 0)
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != "0.00")
              .length === 0
          ) {
            isCorrect = false;
          }

          // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
          if (
            this.partThreeBudgetPlans
              .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
              .reduce((a, b) => a + b, 0) !==
            this.partThreeBudgetList
              .map((x) => parseFloat(x.budget_amount_rsp))
              .reduce((a, b) => a + b, 0)
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (
            !this.partThreeBudgetList ||
            this.partThreeBudgetList.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "oa_list":
          if (!this.OAList || this.OAList.length === 0) isCorrect = false;
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    validatePlanBudget() {
      let isCorrect = true;
      // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
       if (
            this.partThreeBudgetPlans.filter((x) => x.plan_budget !== "")
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != 0)
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != "0.00")
              .length === 0
          ) {
            isCorrect = false;
          }

          // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
          if (
            this.partThreeBudgetPlans
              .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
              .reduce((a, b) => a + b, 0) !==
            this.partThreeBudgetList
              .map((x) => parseFloat(x.budget_amount_rsp))
              .reduce((a, b) => a + b, 0)
          ) {
            isCorrect = false;
          }
      return isCorrect;
    },
    partFourValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (!this.masterData.plan_master || this.masterData.plan_master < 1) {
            isCorrect = false;
          } else {
            isCorrect = false;
            this.masterData.plan_master.forEach((plan) => {
              plan.kpi_masters.forEach((kpi) => {
                if (kpi.kpi_values && kpi.kpi_values.kpi_value > 0) {
                  isCorrect = true;
                }
              });
            });
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "kpi_quantity":
          if (!this.partOneForm.kpi_quantity || !this.partOneForm.kpi_quality) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "kpi_annex_project":
          if (!this.kpi_annex_projects || this.kpi_annex_projects.length === 0)
            isCorrect = false;
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit("General/setModal", {
            title: "ระบบไม่พบไฟล์ที่ร้องขอ",
            theme: "warning",
            text: "กรุณาติดต่อเจ้าหน้าที่",
            showCancel: false,
            buttonText: "ตกลง",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>
